import comp from "./InsightCountPopover";
export default comp;
